import * as React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What is the typical scope of your digital solutions?",
  answer: "We provide end-to-end digital transformation services, including custom software development, cloud infrastructure optimization, and strategic technology consulting tailored to your specific industry needs."
}, {
  question: "How does your pricing model work for enterprise projects?",
  answer: "Our pricing is value-based and transparent, offering both fixed-price milestones for defined projects and flexible retainer models for ongoing development and support cycles."
}, {
  question: "What is the average implementation timeline?",
  answer: "Most core implementations range from 8 to 16 weeks. We utilize agile methodologies to ensure rapid prototyping and iterative delivery of functional modules throughout the process."
}, {
  question: "Do you offer 24/7 technical support?",
  answer: "Yes, we provide tiered support packages including 24/7 critical incident response and dedicated account managers to ensure your systems maintain peak performance at all times."
}, {
  question: "Can your technology stack be customized for our legacy systems?",
  answer: "Absolutely. We specialize in building modern API layers and integration bridges that allow our cutting-edge solutions to communicate seamlessly with your existing legacy infrastructure."
}, {
  question: "How do you handle scalability as our business grows?",
  answer: "Our solutions are built on cloud-native architectures that support auto-scaling. This ensures your platform can handle sudden traffic spikes and long-term growth without performance degradation."
}, {
  question: "What kind of post-launch support is included?",
  answer: "Every launch includes a 90-day stabilization period followed by optional maintenance contracts that cover security updates, performance tuning, and feature enhancements."
}, {
  question: "Are your solutions compliant with global security standards?",
  answer: "Security is integrated into our SDLC. We follow SOC2 and GDPR guidelines, ensuring all data handling and storage meet the highest international security and privacy standards."
}];
export default function CommonSolutionsQuestions() {
  return <section data-section-id="255574" id="common-solutions-questions" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-default font-bold tracking-tighter text-foreground">
            Common Solutions Questions
          </h2>
        </div>

        <div className="w-full mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border">
                <AccordionTrigger className="text-left text-base md:text-xl font-default font-semibold hover:text-primary transition-all py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base md:text-lg font-default leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-16 text-center max-w-3xl mx-auto">
          <p className="text-sm md:text-lg text-muted-foreground font-default leading-relaxed">
            Apex Digital is a leading technology partner specializing in high-performance enterprise solutions. We are committed to delivering scalable, secure, and innovative digital products that drive business growth.{" "}
            <Link to="/ConnectPage" className="text-primary hover:text-primary/80 font-semibold underline underline-offset-4 transition-colors">
              Connect with our experts today.
            </Link>
          </p>
        </div>
      </div>
    </section>;
}